import { createContext } from "react";

const TariffContext = createContext();

export default TariffContext;
